import { IMapboxPlace } from 'src/features/Map/types'
import { ICombinedData } from '../types/ICombinedData'

export const parseMapboxPlaces = (places: IMapboxPlace[]): ICombinedData[] =>
    places.map((item) => {
        return {
            label: item?.place_name,
            value: item.place_name,
            coordinates: item.center as number[],
            id: item?.id,
            type: 'place',
            location: null,
        }
    })
